import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { basicAlert } from '../../utils';

@Component({
  selector: 'app-modal-direccion-envio-clases',
  templateUrl: './modal-direccion-envio-clases.component.html',
  styleUrls: ['./modal-direccion-envio-clases.component.css']
})
export class ModalDireccionEnvioClasesComponent implements OnInit {


  public listaclases: any = [];
  public listacodigos: any = [];

  //Variables para Clase
  public codClase: number;
  public desClase: string;
  public codCodigoClase: number;
  public desCodigoClase: string;

  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private interlocutorService: InterlocutorService,
  ) { }

  ngOnInit(): void {
    this.cargarClases();
  }

  cargarClases() {
    this.spinnerService.activarLoading(true);
    this.interlocutorService.direccion_envio_clases().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.listaclases = resp.body;
    }, err => {
      this.spinnerService.activarLoading(false);
    })

  }

  onChangeClases(valor: any) {
    console.log(valor);
    this.spinnerService.activarLoading(true);
    // this.interlocutorService.direccion_envio_clases_codigos(valor).subscribe((resp: any) => {
    this.interlocutorService.clases_codigos(valor).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.listacodigos = resp.body;
    }, err => {
      this.spinnerService.activarLoading(false);
    })

  }

  _close() {
    this.modalactiveService.dismiss('canceling');
  }

  _ok() {

    if (this.codClase == undefined || this.codClase == null || this.codClase < 0) {
      basicAlert("Clase es requerido.", 'warning', 'Aceptar');
      return;
    }
    if (this.codCodigoClase == undefined || this.codCodigoClase == null) {
      basicAlert("Código es requerido.", 'warning', 'Aceptar');
      return;
    }

    this.listaclases.forEach(element => {
      if (element.codigo == this.codClase) {
        this.desClase = element.descri;
      }
    });

    this.listacodigos.forEach(element => {
      if (element.codigo == this.codCodigoClase) {
        this.desCodigoClase = element.descri;
      }
    });

    let clase: any = {
      clase: this.codClase,
      desclase: this.desClase,
      codigo: this.codCodigoClase,
      descodigo: this.desCodigoClase,
    }
    this.modalactiveService.close(clase);
  }

}
